// assets/javascripts/index.js

import React from "react";
import ReactDOM from "react-dom";
import MyResponsiveRadar from "./bar";
import { ResponsiveBar } from "@nivo/bar";

const AvatarTick = (tick) => {
  let size = 64;

  const images = {
    Gregg: "images/gregg.jpg",
    Anthony: "images/anthony.jpg",
    Erica:
      "https://pbs.twimg.com/profile_images/1143267158253682689/SP4g1F-__400x400.jpg",
    Aaron:
      "https://pbs.twimg.com/profile_images/1256852498800799745/T9iXTJO6_400x400.jpg",
  };

  return (
    <g transform={`translate(${tick.x - size * 1.15},${tick.y - size / 2})`}>
      <clipPath id="clipCircle">
        <circle r={size / 2} cx={size / 2} cy={size / 2} />
      </clipPath>
      <image
        xlinkHref={images[tick.value]}
        height={size}
        width={size}
        clip-path="url(#clipCircle)"
      />
    </g>
  );
};

const el = document.getElementById("hello");
const totalCountBarEl = document.getElementById("total-count-bar");

var episodes = [];
var requestURL = "data/by_type.json";
var request = new XMLHttpRequest();
request.open("GET", requestURL);
request.responseType = "json";
request.send();
request.onload = function() {
  var total = { aaron: {}, erica: {}, gregg: {}, anthony: {} };
  var allTypes = [];

  request.response.forEach((x) => {
    Object.keys(total).forEach((k) => {
      var t = x["type"];
      allTypes.push(t);
      total[k][t] = x[k];
    });
  });
  var typeReformated = {};

  var capitalize = function(k) {
    return k.charAt(0).toUpperCase() + k.slice(1);
  };

  [...new Set(allTypes)].forEach((x) => {
    function wordSpace(match, offset, string) {
      return " " + match.slice(1).toUpperCase();
    }

    typeReformated[x] = capitalize(x)
      .replace(/tv/i, "TV")
      .replace(/-[a-z]/, wordSpace);
  });

  var totalData = Object.keys(total).map((k) => {
    var out = { id: capitalize(k) };
    Object.keys(typeReformated).forEach(
      (tk) => (out[typeReformated[tk]] = total[k][tk]),
    );

    return out;
  });

  function TotalCount() {
    const commonProperties = {
      data: totalData,
      keys: Object.values(typeReformated),
      indexBy: "id",
      margin: {
        top: 10,
        right: 100,
        bottom: 60,
        left: 80,
      },
      legends: [
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ],
      axisLeft: { renderTick: AvatarTick },
      layout: "horizontal",
    };
    return <ResponsiveBar {...commonProperties} />;
  }

  //  ReactDOM.render(<Stats />, el);
  ReactDOM.render(<TotalCount />, totalCountBarEl);
};
